// @flow
import React from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import routerActions from '../../actions/router';
import IconButton from '../IconButton/IconButton';
import {filterCount} from '../../utils/filterCount';
import {FILTERS_MODAL} from '../../actions/modals';

import {trigger, GENERIC_EVENT} from '../../utils/edapWrapper';

import './ButtonBar.less';

type Props = {
    onClickMapButton: () => () => void,
    onClickFiltersButton: () => () => void,
    loading: boolean,
    mapButtonDisabled: boolean
};

type StateProps = {
    numFilters: number
};

export const ButtonBar = ({
    onClickMapButton,
    onClickFiltersButton,
    numFilters,
    loading,
    mapButtonDisabled
}: Props & StateProps) => {
    const handleFiltersButtonClick = () => {
        trigger(GENERIC_EVENT, {
            eventaction: 'filter menu clicked',
            eventcategory: 'search'
        });
        onClickFiltersButton();
    };
    const handleMapButtonClick = () => {
        trigger(GENERIC_EVENT, {
            eventcategory: 'search',
            eventaction: 'list to map click',
            eventlabel: 'button'
        });
        onClickMapButton();
    };

    return (
        <div className="ButtonBar" data-wdio="ButtonBar">
            <IconButton icon="sliders" onClick={handleFiltersButtonClick}>
                <FormattedMessage
                    id="filtersButton"
                    description="Button to open Filters menu"
                    defaultMessage="Filters {filterNumber}"
                    values={{
                        filterNumber: filterCount(loading ? 0 : numFilters)
                    }}
                />
            </IconButton>
            <IconButton
                icon="map-pin"
                disabled={mapButtonDisabled}
                onClick={handleMapButtonClick}
            >
                <FormattedMessage
                    id="mapButton"
                    description="Button to switch to map view"
                    defaultMessage="Map"
                />
            </IconButton>
        </div>
    );
};

ButtonBar.displayName = 'ButtonBar';

const mapDispatchToProps = {
    onClickMapButton: routerActions.map,
    onClickFiltersButton: () => routerActions.pushModal(FILTERS_MODAL)
};
const mapStateToProps = ({searchParams}) => ({
    numFilters: (searchParams && searchParams.numFilters) || 0
});
export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(ButtonBar);
